import script from "./Page10.vue?vue&type=script&setup=true&lang=js"
export * from "./Page10.vue?vue&type=script&setup=true&lang=js"

import "./Page10.vue?vue&type=style&index=0&id=f5942a30&lang=less"

const __exports__ = script;

export default __exports__